// Area Navigation component

// This file was once generated when you created this area
// but you can edit it freely

import {
  type AreaNavigationProps,
  NavigationItem,
} from '@backoffice-frontend/patterns'
import { PhoneIcon } from '@moia-dev/pace-icons'
import { AppAccessControlAreaRoutes } from './AppAccessControlAreaRoutes'

export const AppAccessControlAreaNavigationIcon = PhoneIcon

export const AppAccessControlAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={AppAccessControlAreaRoutes.route}
      Icon={PhoneIcon}
    />
  )
}
